import React from "react";
import { useMerchantTheme } from "@/hooks/useMerchantTheme";
import Header from "./Header";
import Header1xbet from "./Header1xbet";

function HeaderIndex(props) {
  const { is1xbet } = useMerchantTheme();
  return is1xbet ? <Header1xbet {...props} /> : <Header {...props} />;
}

export default HeaderIndex;
